(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.faqModernInit === 'true') return;
    section.dataset.faqModernInit = 'true';

    var items = section.querySelectorAll('[data-faq-item]');
    var filterButtons = section.querySelectorAll('[data-faq-filter]');
    var filterSelect = section.querySelector('[data-faq-filters-select]');
    var filtersNav = section.querySelector('[data-faq-filters]');
    var filtersWrap = section.querySelector('[data-faq-filters-wrap]');
    var filtersTrack = section.querySelector('[data-faq-filters-track]');
    var filtersPrev = section.querySelector('[data-faq-filters-prev]');
    var filtersNext = section.querySelector('[data-faq-filters-next]');
    var emptyState = section.querySelector('[data-faq-empty]');
    var allowMultiple = section.dataset.allowMultiple === 'true';
    var scrollOffset = parseInt(section.dataset.scrollOffset || '70', 10);

    function scrollActiveTabIntoView() {
      if (!filtersNav) return;
      var active = filtersNav.querySelector('.faq-modern__filter.is-active');
      if (!active) return;
      var navRect = filtersNav.getBoundingClientRect();
      var tabRect = active.getBoundingClientRect();
      var delta =
        tabRect.left - navRect.left - (navRect.width - tabRect.width) / 2;
      filtersNav.scrollLeft += delta;
    }

    function updateFilterSlider() {
      if (!filtersWrap || !filtersNav) return;
      var maxScroll = filtersNav.scrollWidth - filtersNav.clientWidth;
      var isScrollable = maxScroll > 4;
      var atStart = filtersNav.scrollLeft <= 4;
      var atEnd = filtersNav.scrollLeft >= maxScroll - 4;

      filtersWrap.classList.toggle('is-scrollable', isScrollable);
      filtersWrap.classList.toggle('is-at-start', atStart || !isScrollable);
      filtersWrap.classList.toggle('is-at-end', atEnd || !isScrollable);
      if (filtersTrack) {
        filtersTrack.classList.toggle('is-scrollable', isScrollable);
      }

      if (window.matchMedia('(min-width: 750px)').matches) {
        if (filtersPrev) filtersPrev.hidden = true;
        if (filtersNext) filtersNext.hidden = true;
        return;
      }

      if (filtersPrev) {
        filtersPrev.hidden = !isScrollable;
        filtersPrev.disabled = atStart;
      }
      if (filtersNext) {
        filtersNext.hidden = !isScrollable;
        filtersNext.disabled = atEnd;
      }
    }

    function scrollFiltersBy(direction) {
      if (!filtersNav) return;
      var amount = Math.max(filtersNav.clientWidth * 0.65, 120);
      filtersNav.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    function linkifyEmailsInTextNode(textNode) {
      var emailPattern = /\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b/g;
      var text = textNode.nodeValue;
      var matches = [];
      var match;

      while ((match = emailPattern.exec(text)) !== null) {
        matches.push({
          email: match[1],
          index: match.index,
          length: match[0].length
        });
      }

      if (!matches.length) return;

      var fragment = document.createDocumentFragment();
      var lastIndex = 0;

      matches.forEach(function (item) {
        if (item.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, item.index)));
        }

        var link = document.createElement('a');
        link.href = 'mailto:' + item.email;
        link.textContent = item.email;
        fragment.appendChild(link);
        lastIndex = item.index + item.length;
      });

      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      textNode.parentNode.replaceChild(fragment, textNode);
    }

    function linkifyEmailsInAnswers() {
      var emailTest = /\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b/;

      section.querySelectorAll('.faq-modern__answer').forEach(function (answer) {
        var textNodes = [];
        var walker = document.createTreeWalker(answer, NodeFilter.SHOW_TEXT);
        var node;

        while ((node = walker.nextNode())) {
          if (!node.nodeValue || !emailTest.test(node.nodeValue)) continue;
          if (node.parentElement && node.parentElement.closest('a')) continue;
          if (node.parentElement && /^(SCRIPT|STYLE)$/i.test(node.parentElement.tagName)) continue;
          textNodes.push(node);
        }

        textNodes.forEach(linkifyEmailsInTextNode);
      });
    }

    function normalizeAnswerLinks() {
      section.querySelectorAll('.faq-modern__answer a[href]').forEach(function (link) {
        var href = link.getAttribute('href') || '';

        if (href.indexOf('mailto:') === 0) {
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }

        link.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      });
    }

    function initFilterSlider() {
      if (!filtersNav) return;

      updateFilterSlider();
      scrollActiveTabIntoView();

      filtersNav.addEventListener('scroll', updateFilterSlider, { passive: true });

      if (filtersPrev) {
        filtersPrev.addEventListener('click', function () {
          scrollFiltersBy(-1);
        });
      }
      if (filtersNext) {
        filtersNext.addEventListener('click', function () {
          scrollFiltersBy(1);
        });
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          updateFilterSlider();
          scrollActiveTabIntoView();
        }, 150);
      });
    }

    function setActiveFilter(category) {
      filterButtons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-faq-filter') === category;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      if (filterSelect) {
        filterSelect.value = category;
      }
      requestAnimationFrame(function () {
        scrollActiveTabIntoView();
        updateFilterSlider();
      });
    }

    function applyFilter(category) {
      var visibleCount = 0;
      items.forEach(function (item) {
        var itemCategory = item.getAttribute('data-faq-category');
        var show = category === 'all' || itemCategory === category;
        item.classList.toggle('is-hidden', !show);
        if (show) visibleCount += 1;
      });
      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }
      setActiveFilter(category);
    }

    function closeItem(item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('[data-faq-answer]');
      if (!trigger || !answer) return;
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
      var icon = item.querySelector('[data-faq-icon]');
      if (icon) icon.textContent = '+';
    }

    function openItem(item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('[data-faq-answer]');
      if (!trigger || !answer) return;
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
      var icon = item.querySelector('[data-faq-icon]');
      if (icon) icon.textContent = '\u2212';
    }

    function toggleItem(item) {
      var isOpen = item.classList.contains('is-open');
      if (!allowMultiple) {
        items.forEach(function (other) {
          if (other !== item) closeItem(other);
        });
      }
      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
        var top = item.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
        window.requestAnimationFrame(function () {
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      }
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-faq-filter'));
      });
    });

    if (filterSelect) {
      filterSelect.addEventListener('change', function () {
        applyFilter(filterSelect.value);
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        toggleItem(item);
      });
    });

    linkifyEmailsInAnswers();
    normalizeAnswerLinks();
    applyFilter('suppliments');
    initFilterSlider();
  }

  function initAll() {
    document.querySelectorAll('[data-faq-modern]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-faq-modern]');
    if (section) initSection(section);
  });
})();
